<div class="ticket-list">
    <!-- New ticket button -->
    <div class="ticket-list-actions">
        <button class="sw-btn sw-btn-primary" (click)="newTicket.emit()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
            New Request
        </button>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="ticket-list-status">
        <div class="sw-spinner"></div>
        <span>Loading tickets...</span>
    </div>

    <!-- Error -->
    <div *ngIf="error && !loading" class="ticket-list-status ticket-list-error">
        <p>{{ error }}</p>
        <button class="sw-btn sw-btn-outline" (click)="loadTickets()">Retry</button>
    </div>

    <!-- Empty -->
    <div *ngIf="!loading && !error && tickets.length === 0" class="ticket-list-status">
        <p>No support requests yet.</p>
        <p class="text-muted">Tap "New Request" to get help.</p>
    </div>

    <!-- Ticket items -->
    <div *ngFor="let ticket of tickets" class="ticket-item" [class.unread]="ticket.unread"
        (click)="selectTicket.emit(ticket.issueKey)">
        <div class="ticket-item-header">
            <span class="ticket-key-wrap">
                <span *ngIf="ticket.unread" class="ticket-unread-dot" title="New activity" aria-label="New activity"></span>
                <span class="ticket-key">{{ ticket.issueKey }}</span>
            </span>
            <span class="ticket-status" [ngClass]="getStatusClass(ticket.currentStatus?.status)">
                {{ ticket.currentStatus?.status || 'Unknown' }}
            </span>
        </div>
        <div class="ticket-summary">{{ ticket.requestFieldValues?.summary || ticket.summary }}</div>
        <div class="ticket-meta">{{ ticket.createdDate?.friendly || ticket.createdDate }}</div>
    </div>
</div>
